"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartDocFieldLogic = void 0;
var smartdoc_fieldtype_1 = require("./smartdoc.fieldtype");
Object.defineProperty(exports, "SmartDocFieldLogic", { enumerable: true, get: function () { return smartdoc_fieldtype_1.SmartDocFieldLogic; } });
